import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Activity } from 'lucide-react';
import { navLinks } from '../mock';
import { Button } from './ui/button';

const Logo = () => (
  <Link to="/" className="flex items-center gap-2 shrink-0">
    <div className="relative flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-brand-blue to-brand-orange">
      <Activity className="w-6 h-6 text-white" strokeWidth={2.5} />
    </div>
    <div className="leading-tight">
      <div className="font-heading font-extrabold text-[17px] md:text-lg text-brand-blue tracking-tight">Trusted Companion</div>
      <div className="font-heading font-semibold text-[11px] text-brand-orange -mt-0.5 tracking-[0.15em] uppercase">Health Care</div>
    </div>
  </Link>
);

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className={`sticky top-0 z-50 w-full bg-white transition-shadow duration-300 ${scrolled ? 'shadow-md' : 'shadow-sm'}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Logo />

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => {
              const active = location.pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`font-body text-[15px] font-semibold transition-colors duration-200 relative py-1 ${active ? 'text-brand-orange' : 'text-slate-700 hover:text-brand-blue'}`}
                >
                  {link.label}
                  {active && <span className="absolute -bottom-0.5 left-0 w-full h-0.5 bg-brand-orange rounded-full" />}
                </Link>
              );
            })}
          </nav>

          <div className="hidden lg:block">
            <Button asChild className="bg-brand-blue hover:bg-brand-blue-dark text-white font-semibold px-7 py-5 rounded-full text-[15px]">
              <a href="#login">Login</a>
            </Button>
          </div>

          <button className="lg:hidden text-slate-800" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`lg:hidden overflow-hidden transition-all duration-300 ${open ? 'max-h-[420px] border-t border-slate-100' : 'max-h-0'}`}>
        <nav className="flex flex-col px-5 py-4 gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`font-body font-semibold py-3 px-3 rounded-md ${location.pathname === link.to ? 'text-brand-orange bg-brand-blue-light' : 'text-slate-700'}`}
            >
              {link.label}
            </Link>
          ))}
          <Button className="bg-brand-blue hover:bg-brand-blue-dark text-white font-semibold mt-2 rounded-full">Login</Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
